import React from "react";
import { formatPrice } from "../../lib/utils";
import { storeConfig } from "../../config/store.config";

const OrderSummary = ({
  subtotal,
  discount = 0,
  total,
  appliedPromo,
  promoInput,
  setPromoInput,
  onApplyPromo,
  onRemovePromo,
  promoError,
  children,
}) => {
  const showPromo = storeConfig.promoEnabled && typeof setPromoInput === "function";
  return (
    <div className="border border-ink p-6" data-testid="order-summary">
      <h3 className="mb-5 font-display text-2xl uppercase tracking-tight">Summary</h3>

      {showPromo && (
        <div className="mb-5">
          {appliedPromo ? (
            <div className="flex items-center justify-between border border-brand bg-brand/10 px-3 py-2">
              <span className="font-mono text-xs uppercase tracking-wider">
                {appliedPromo} applied
              </span>
              <button
                onClick={onRemovePromo}
                className="font-mono text-xs uppercase text-ink/60 hover:text-ink"
                data-testid="promo-remove-btn"
              >
                Remove
              </button>
            </div>
          ) : (
            <div className="flex gap-2">
              <input
                value={promoInput}
                onChange={(e) => setPromoInput(e.target.value.toUpperCase())}
                placeholder="Promo code"
                aria-label="Promo code"
                data-testid="promo-input"
                className="w-full border border-ink/25 bg-transparent px-3 py-2.5 font-mono text-sm uppercase tracking-wider focus:border-ink focus:outline-none"
              />
              <button
                onClick={onApplyPromo}
                className="btn-outline px-5 py-2.5"
                data-testid="promo-apply-btn"
              >
                Apply
              </button>
            </div>
          )}
          {promoError && (
            <p className="mt-2 font-mono text-xs text-red-600" data-testid="promo-error">
              {promoError}
            </p>
          )}
        </div>
      )}

      <div className="space-y-3 border-t border-ink/10 pt-4 text-sm">
        <div className="flex justify-between">
          <span className="text-ink/60">Subtotal</span>
          <span className="font-mono" data-testid="summary-subtotal">{formatPrice(subtotal)}</span>
        </div>
        {discount > 0 && (
          <div className="flex justify-between text-brand-dark">
            <span>Discount</span>
            <span className="font-mono" data-testid="summary-discount">-{formatPrice(discount)}</span>
          </div>
        )}
        <div className="flex justify-between">
          <span className="text-ink/60">Shipping</span>
          <span className="font-mono text-ink/50">To be confirmed</span>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-ink pt-4">
        <span className="label-mono">Total</span>
        <span className="font-mono text-xl" data-testid="summary-total">{formatPrice(total)}</span>
      </div>

      {children && <div className="mt-6">{children}</div>}
    </div>
  );
};

export default OrderSummary;
